import React, { FC, ReactNode } from "react";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { ReactComponent as DownloadIcon } from "src/assets/icons/download.svg";

interface Props {
  className?: string;
  children: ReactNode;
  variant?: ButtonVariants;
  onClick: () => void;
};

export const ButtonDownload: FC<Props> = ({
  className,
  children,
  variant,
  onClick,
}) => {
  return (
    <Button
      className={cn("flex gap-2.5 py-4", className)}
      variant={variant}
      onClick={onClick}
    >
      <DownloadIcon />
      <span>{children}</span>
    </Button>
  );
};

